import { useQuery } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

export const useGetConfig = (runInterval = true) => {
  const { managedConfigController } = useAvApi();

  const data = useQuery({
    queryKey: ['configuration'],
    queryFn: async () => {
      const data = await managedConfigController.getConfiguration();

      return data.data;
    },
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
    refetchInterval: runInterval === false ? undefined : 30000,
  });

  return data;
};
